import { useEffect } from 'react';
import { CircularProgress, Typography, Box } from '@mui/material';
import Login from '../../redux/containers/login/Login';
import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ children, profile, getProfile, isLoadingProfile, isAuthenticated, homePath }) => {
  useEffect(() => {
    getProfile();
  }, [getProfile]);

  if (isLoadingProfile) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="100vh"
        flexDirection="column"
        sx={{ overflow: 'hidden',
          backgroundImage: 'url(https://strobnett.blob.core.windows.net/images/Microsoft_login_screen.svg)',
          backgroundRepeat: 'no-repeat',  
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          }}
      >
        <CircularProgress size={80} />
        <Typography variant="h6" style={{ marginTop: '20px' }}>
          Cargando...
        </Typography>
      </Box>
    );
  }
  
  // If user is not authenticated, redirect to login
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }
  
  // Si se especifica una ruta homePath, y la ruta actual es '/', redirigir según el rol
  if (homePath && window.location.pathname === '/') {
    const userRole = profile?.role || 'Agente';
    
    // Determinar la página de inicio según el rol
    let redirectTo;
    switch (userRole) {
      case 'Administrador':
      case 'Supervisor':
        redirectTo = '/'; // Dashboard
        break;
      default:
        redirectTo = '/chats'; // Agentes van a mensajes
        break;
    }
    
    // Si el usuario no debería ver la ruta principal (agentes), redirigirlos
    if (userRole === 'Agente' && window.location.pathname === '/') {
      return <Navigate to={redirectTo} replace />;
    }
  }
  
  // If authenticated, render children
  return children;
};

export default ProtectedRoute;
